import { useState } from "react";

/**
 * 数字人相关状态 Hook
 */
const useDigitalHumanState = () => {
  const [currentExpertName, setCurrentExpertName] = useState('');
  const [currentSpeechText, setCurrentSpeechText] = useState('');
  const [isExpertServiceAvailable, setIsExpertServiceAvailable] = useState(false);
  const [classMode, setClassMode] = useState(() => {
    const saved = localStorage.getItem('classModeEnabled');
    return saved === 'true';
  });
  const [digitalHumanGlobalEnabled, setDigitalHumanGlobalEnabled] = useState(() => {
    // 从 localStorage 读取用户偏好
    const saved = localStorage.getItem('digitalHumanGlobalEnabled');
    const migrated = localStorage.getItem('digitalHumanMigrated'); // 迁移标记
    
    // 🔧 一次性迁移：如果未迁移且之前为 'true'，重置为 'false'
    if (!migrated && saved === 'true') {
      localStorage.setItem('digitalHumanGlobalEnabled', 'false');
      localStorage.setItem('digitalHumanMigrated', 'true'); // 标记已迁移
      console.log('🔧 [一次性迁移] 数字人开关已重置为默认关闭状态');
      return false;
    }
    
    return saved === null ? false : saved === 'true'; // 未设置时默认 false（关闭）
  });
  const [currentFileExpertName, setCurrentFileExpertName] = useState('');
  const [currentFileExpertText, setCurrentFileExpertText] = useState('');
  const [simulationConfig, setSimulationConfig] = useState(null);

  // 重置数字人状态
  const resetDigitalHumanState = () => {
    setCurrentExpertName('');
    setCurrentSpeechText('');
    setIsExpertServiceAvailable(false);
    setCurrentFileExpertName('');
    setCurrentFileExpertText('');
    setSimulationConfig(null);
  };

  // classMode 持久化
  const setClassModeWithPersist = (value) => {
    localStorage.setItem('classModeEnabled', value ? 'true' : 'false');
    setClassMode(value);
  };

  return {
    currentExpertName,
    setCurrentExpertName,
    currentSpeechText,
    setCurrentSpeechText,
    isExpertServiceAvailable,
    setIsExpertServiceAvailable,
    classMode,
    setClassMode: setClassModeWithPersist,
    digitalHumanGlobalEnabled,
    setDigitalHumanGlobalEnabled,
    currentFileExpertName,
    setCurrentFileExpertName,
    currentFileExpertText,
    setCurrentFileExpertText,
    simulationConfig,
    setSimulationConfig,
    resetDigitalHumanState,
  };
};

export default useDigitalHumanState;
